import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { CONTACT_INFO } from "@/data/content";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative border-t border-white/10 bg-[#0A0A0A]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-16">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <Logo className="text-[52px] text-white mb-6" />
            <p className="text-white/50 text-sm leading-relaxed max-w-sm mt-2">
              Women-Owned Small Business & SBA 8(a) certified. Design-build, modular, and
              secure facility construction for Federal agencies and the DoD.
            </p>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-blue-400 mb-5">Navigate</p>
            <ul className="space-y-3">
              {[
                { label: "Home", path: "/" },
                { label: "Team", path: "/about" },
                { label: "Capabilities", path: "/capabilities" },
                { label: "Certifications", path: "/certifications" },
                { label: "Contact", path: "/contact" },
              ].map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="text-white/60 hover:text-white transition-colors text-sm">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-blue-400 mb-5">Registrations</p>
            <ul className="space-y-3 text-sm text-white/60 font-mono">
              <li>CAGE · {CONTACT_INFO.cage}</li>
              <li>UEI · {CONTACT_INFO.uei}</li>
              <li>DUNS · {CONTACT_INFO.duns}</li>
              <li>GSA · {CONTACT_INFO.gsa}</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} Sabala Management LLC. All rights reserved.</span>
          <span className="font-mono">{CONTACT_INFO.address}</span>
        </div>
      </div>
    </footer>
  );
}
